module.exports = __webpack_public_path__ + "static/media/image-icon.2ad444ce.svg";